export class MSupplier {
  indexNo: number;
  name: string;
  contactName: string;
  contactNo: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  creditPeriod: number;
  accAccount: number;
  type: string;
}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-supplier/model/m-supplier.ts